import * as p from '@clack/prompts'
import { VERCEL_NEON_URL } from '@cli-constants/prompt-copy.js'
import { openBrowser } from '@cli-utils/process.js'
import pc from 'picocolors'

export function openBrowserVercelNeon(): void {
  openBrowser(VERCEL_NEON_URL)
  p.log.info(
    `Opening Vercel... Create a Neon Postgres database, then copy the ${pc.cyan('DATABASE_URL')} from the dashboard.`
  )
}
